import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsConfig, I18nModule, provideDefaultConfig } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, SupplementHashAnchorsModule } from "@spartacus/storefront";
import { KbParagraphComponent } from "./kb-paragraph.component";


@NgModule({
    imports: [
        CommonModule,
        PageLayoutModule,
        OutletModule,
        OutletRefModule,
        PageSlotModule,
        I18nModule,
        SupplementHashAnchorsModule
    ],
    providers: [
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                CMSParagraphComponent: {
                    component: KbParagraphComponent,
                },
                CMSTabParagraphComponent: {
                    component: KbParagraphComponent,
                },
            },
        }),
    ],
    declarations: [KbParagraphComponent],
    exports: [KbParagraphComponent],
})
export class KbParagraphModule {

}
